import { server } from '../helpers';

export const getPlaceGiftCardData = (placeId: number, slug: string) => {
  const uriSlug = encodeURIComponent(slug);
  return server.request
    .get(`/places/${placeId}/giftcarddata?slug=${uriSlug}`)
    .then(server.handleSuccess)
    .catch(server.handleError);
};
